import React from 'react';
import classNames from 'classnames';

const MarkerBadge = ({ className, children }) => (
  <span className={classNames('MarkerBadge', className)}>{children}</span>
);

export default MarkerBadge;



// WEBPACK FOOTER //
// ./src/components/common/MarkerBadge/index.jsx